module.exports = __webpack_public_path__ + "static/media/logo.307cd58d.png";